import { EActionState } from './actionstate';
import { EFollowUpStatus, EMobileStatus } from './appointments';
import { DefaultStringValue, IFormValue } from './forms';

// export interface IFollowUp {
// 	comments: string;
// 	endTime?: string;
// 	endTimeUtc?: string;
// 	id: string;
// 	leadDate: string;
// 	mobileStatus: EMobileStatus;
// 	opportunityId: string;
// 	ownerId: string;
// 	sourceCreated: string;
// 	sourceModified: string;
// 	specialInstructions: string;
// 	startTime?: string;
// 	startTimeUtc?: string;
// 	status: string;
// 	subType: string;
// 	timeZone: string;
// 	type: string;
// }

export interface ICreateFollowUpRequest {
	appointmentDate: string;
	duration: string;
	mobileStatus: EMobileStatus;
	opportunityId: string;
	ownerId: string;
	specialInstructions: string;
	startTime: string;
	status: EFollowUpStatus;
	subType: string;
	type: string;
}

export interface IFollowUpCreateFormState {
	formData: {
		type: IFormValue<string>;
		date: IFormValue<string>;
		time: IFormValue<string>;
		length: IFormValue<string>;
		specialInstructions: IFormValue<string>;
	};
}

export const DefaultFollowUpCreateFormState: IFollowUpCreateFormState = {
	formData: {
		type: DefaultStringValue,
		date: DefaultStringValue,
		time: DefaultStringValue,
		length: DefaultStringValue,
		specialInstructions: DefaultStringValue
	}
};

export interface IFollowUpUpdateFormState {
	formData: {
		followUpResult: IFormValue<string>;
	};
}

export const DefaultFollowUpUpdateFormState: IFollowUpUpdateFormState = {
	formData: {
		followUpResult: DefaultStringValue
	}
};

export interface IFollowUpCloseFormState {
	formData: {
		reasonForNoPurchase: IFormValue<string>;
		comments: IFormValue<string>;
	};
}

export const DefaultFollowUpCloseFormState: IFollowUpCloseFormState = {
	formData: {
		reasonForNoPurchase: DefaultStringValue,
		comments: DefaultStringValue
	}
};

export interface IFollowUpState {
	accept: EActionState;
	arrivalNotice: EActionState;

	acceptEnabled: boolean;
	arrivalNoticeEnabled: boolean;
}

export const DefaultFollowUpState: IFollowUpState = {
	accept: EActionState.PENDING,
	arrivalNotice: EActionState.PENDING,

	acceptEnabled: false,
	arrivalNoticeEnabled: false
};
